import { get, reduce, debounce } from 'lodash';
import {
  AUDIO_SUB_TYPES,
  AccountType,
  BILLING_CYCLE,
  MRS_STATUS_TYPE_MAP,
  planTypes,
  twinPlancodesMap,
  ZONE_BASIC_PLUS_CATEGORIES,
  BASE_PLAN_SUB_TYPES,
  ACCOUNT_SALE_CHANNEL,
} from '@/common/constants';
import { getBasePlanInfo, groupByPlanTypeGetter, getMeetingPlans, getPlansMap } from '@/common/product';
import pageFlow from '@/flows';
import { getCartInfo } from "@/common/service/default-mapper";
import { COUPON_ACTION_TYPES } from '@/store/modules/coupon';
import _ from 'lodash';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { boughtPlanFilter } from '@/common/service/bought-plans-filter';
import { checkMRSChange, planCodeMapSubscriptionDisabled } from '@/utils/validator';
import { PAYMENT_ACTION_TYPES } from '@/store/modules/payment';
import { ADDRESS_ACTION_TYPES } from '@/store/modules/address';
import { sortSelectedPlansMethod } from '@/plans';
import {
  cancellationCouponSource,
  couponFetchStatus,
  couponSourceTypeMap,
} from '@/views/config/coupon/helper/constant';
import { createCouponPayloadBuilder } from '@/common/service/coupon-payload-builder';
import { plansof } from '@/utils/chain';
import { billingCycleToValueMap } from '@/utils';
import log from '@/common/log';
import { unlimitedAudioLicenseGetter } from '@/common/service/audio-us-ca';
import { plansofBizBundle } from '@/plans/ZOOM_ONE_BUNDLE/utils';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';
import { isOnlineNotSupportPlan } from '@/common/service/non-standard-billing-cycle-utils';
import { MIGRATE_FLOW_TYPES } from '@/plans/ZOOM_MEETING/dialog/migration-plan';
import { $context, $query } from '@/global-install';
import { getCountryCodeByBusinessCountry } from '@/plans/ZOOM_MEETING/config/healthcare/helpers'
import { isFromCampaignLink } from '@/views/config/coupon/helper/utils';
import { ZoomRoomCategories } from '@/plans/ZOOM_ROOMS/pre';
import { getFreeTrialPlansByCampaignName } from '@/apis';
import { isFromShoppingCart } from '@/views/config/shopping-cart/persist/plan-remove';
import { getInrDiscountAmount } from '@/views/config/shopping-cart/inr-discount/inr-discount';
import { PROMOTION_ACTION_TYPES } from '@/store/modules/promotion';
import { getEffectiveAmount } from '@/utils/downsell-price';

import { EVENT_TYPES, emit } from '@/utils/event-emitter.js'
import { REFERRAL_ACTION_TYPES } from '@/store/modules/refer-a-friend';
import {
  getReferAFriendDiscountAmount
} from '@/views/config/shopping-cart/refer-a-friend-discount/refer-a-friend-discount';
import { getSelectedPlanListPayLoad } from '@/store/helper';
import { computedPbxCallingPlans } from '@/common/service/computers/plans/pbx';

const SELECTED_PLANS_MAP_0_KEY = window.location.search;

const getDefaultCouponPayload = () => {
  return {
    cancelCampaign: false,
    fromCampaignLink: false,
    supportCoupon: false,
    code: undefined,
  }
};

function getDeterminePlanBeenEditedData(plan) {
  // diff plan codes but the same thing
  const plan_code = twinPlancodesMap[plan.plan_code] || plan.plan_code;
  const quantity = plan.cartInfo.selected_number;
  let special = '';
  // tollFree cares whether tollFreeProfileData changes
  if (plan.type === planTypes.TOLLFREE && plan.category === AUDIO_SUB_TYPES.TOLL_FREE) {
    special = `tollFreeProfileData=${JSON.stringify(plan.cartInfo.tollFreeProfileData || {})}`;
  }
  return `${plan_code}*${quantity}${special}\n`;
}

export function getMultipleRatePlanSumPrice(boughtPlan, selectedNumber) {
  const boughtNum = _.sum(boughtPlan.ratePlans.map((ratePlan) => ratePlan.quantity));
  const addNum = selectedNumber - boughtNum;
  const addSumPrice = boughtPlan.ratePlans.find(r => r.useForUpsell)?.price * addNum;
  return _.sum(boughtPlan.ratePlans.map((ratePlan) => ratePlan.quantity * ratePlan.price)) + addSumPrice;
}

export function isOnlineFreeTrailAccountBySubscriptions(subscriptions = [], freeTrialPlans = []) {
  // zoom phone online free trial
  if (pageConfig.accountType === AccountType.ACCOUNT_ZOOM_PHONE) {
    return !!computedPbxCallingPlans(freeTrialPlans).find(item => item.isFreeTrial || item.isOnlineFreeTrial);
  }
  return (
    pageConfig.accountType === AccountType.ACCOUNT_ZOOM_BASIC_MEETING &&
    subscriptions.length > 0 &&
    subscriptions.filter((item) => !(item.isFreeTrial || item.isOnlineFreeTrial)).length === 0
  );
}

const state = {
  refreshCount: 0,
  planMapFlat: [],
  planMapFlatRaw: [], // untouched full plans list, planMapFlat is changed through multiple loaders
  boughtPlans: [],
  freeTrialPlans: [],
  subscriptions: [],
  preloadCartInfo: {},
  persist: {}, // TODO persist data should be dependent on flow type: destroy persist of different flow
  selectedPlansMap0: {},
  allPlanMap: {},
  cartIsReady: false,
  flowInitIsReady: false,
  assignInfo: {}, // key is planCode, value is object
  cmrUsedValue: {},
  persistState: {
    downgradeState: {
      //status: 0, //-1:down 0:unChange 1:up
    },
    migratePlanState: {
      planList: [],
      flow: '',
      hotCache: {},
      migrateType: ''
    },
    confirmationDetails: {},
    accountBizInfo:{
      businessPersonalAccount:		'',
      businessSize: '',
      businessRegion: '',
    },
  }, // business persist state
  currentEditPlan :{},
  sourcePlan: null, // for upgrade
  // PRO INCREASE - store the old price when user not save address and try to go back
  proIncreaseMapMonthly: {
    address: undefined,
    oldPlanCode: undefined,
    oldPlanAmount: undefined,
    newPlanCode: undefined,
    newPlanAmount: undefined
  },
  proIncreaseMapYearly: {
    address: undefined,
    oldPlanCode: undefined,
    oldPlanAmount: undefined,
    newPlanCode: undefined,
    newPlanAmount: undefined
  },
  _healthcareInfo: {
    agreementAccepted: false,
    businessCountry: '',
  },
  initPlansOrder: [],
  draftPlanFilterKeys: [],
  trialInfoMap: {},
  pastPlans: [],
  zcmDomainWarning: false, // Warning flag for ZCM corporate domain restriction
  initialPlanCodes: [],
  oldPlanCode: null,
  // Free trial ineligible (e.g. ZP AIC campaign API returns error): show ineligible page instead of redirect
  ineligible: false,
  ineligibleMessage: '',
  // Temporary data storage for route navigation
  routerTempData: null,
  isZPAContext: false,
};

const getters = {
  routerTempData: (state) => state.routerTempData,
  isZPAContext: (state) => state.isZPAContext,
  allPlanMap: (state) => state.allPlanMap,
  cartIsReady: (state) => state.cartIsReady,
  flowInitIsReady: (state) => state.flowInitIsReady,
  boughtPlans: (state) => state.boughtPlans,
  freeTrialPlans: (state) => state.freeTrialPlans,
  currentFlowInvolvedFreeTrialUpgrade: (state, getters) => {
    if (window.$context?.is?.trial2paid) {
      return true;
    }

    // check if there is any selected free trial plan that has been bought
    const existsSelectedFreeTrialPlanHaveBought = _.some(getters.getSelectedPlans,
      plan => plan?.freeTrialPlanInfo?.isOnlineFreeTrial || plan?.freeTrialPlanInfo?.isFreeTrial);

    if (window.$context?.is?.add2cart && existsSelectedFreeTrialPlanHaveBought) {
      return true;
    }

    return false;
  },
  planMapFlat: (state) => state.planMapFlat,
  planMapFlatRaw: (state) => state.planMapFlatRaw,
  getInitPlansOrder: (state) => state.initPlansOrder,
  draftPlanFilterKeys: (state) => state.draftPlanFilterKeys,
  groupByPlanCodePlanMap: (state) => getPlansMap(state.planMapFlat),
  getTypeGroupSelectedPlans: (state, { getSelectedPlans }) => groupByPlanTypeGetter(getSelectedPlans),
  oldPlanCode: (state) => state.oldPlanCode,
  ineligible: (state) => state.ineligible,
  ineligibleMessage: (state) => state.ineligibleMessage,
  // initial state of shopping cart plans map{code:quantity}
  getSelectedPlansMap0: state => state.selectedPlansMap0[SELECTED_PLANS_MAP_0_KEY]??{},
  // shopping cart plans.
  getSelectedPlans: ({ planMapFlat }) => {
    return planMapFlat.filter(v => v.cartInfo?.selected_number > 0).sort(sortSelectedPlansMethod);
  },
  // current purchase flow only have free trial plans
  isPureFreeTrialBuyPlanFlow: (state, getters) => {
    const filterPlans = _.filter(getters.getSelectedPlans, plan => {
      // exclude zoom phone base plan pay as you go plan
      if (plan?.type === planTypes.ZOOM_PHONE && plan?.is_payg) {
        return false;
      }
      return true;
    });

    if (!filterPlans?.length) return false;

    return _.every(filterPlans, plan => (plan?.isOnlineFreeTrial || plan?.isFreeTrial))
  },
  getSelectedPlansCartInfo: ({ planMapFlat }) => {
    return planMapFlat.filter(v => v.cartInfo?.selected_number > 0).sort(sortSelectedPlansMethod).map(item => {
      return {
        ...item,
        selected_number: item.cartInfo.selected_number,
      }
    });
  },
  editablePlansInBought(state, getters){
    const { boughtPlans } = getters;
    const selectedPlansMap0 = state.selectedPlansMap0[SELECTED_PLANS_MAP_0_KEY]??{};
    return boughtPlans.filter(x => selectedPlansMap0[x.plan_code]).filter(x => getters.basicConfig.isExpireAccountWithPaidPlan ? x.cancelled != 1 : true); // [init0 plans] ∩ [bought plans] => original target edit plans
  },
  isMsqEdit(state, getters) {
    if (pageConfig.type !== flowTypes.edit) return false;
    const editCategory = getters.currentEditPlan?.category;
    if (!editCategory) return false;
    const boughtCategoryPlans = getters.boughtPlans.filter(plan => plan.category === editCategory);
    return boughtCategoryPlans.length > 1;
  },
  isSelectedSameAsEditablePlansInBoughtForMsqEdit: (state, getters) => {
    const currentEditPlan = getters.currentEditPlan;
    const selectedPlans = getters.getSelectedPlans;
    if (selectedPlans.length !== 1 || !currentEditPlan) return false;
    const selectedPlanCode = selectedPlans[0].plan_code;
    const selectedPlanQty = selectedPlans[0].cartInfo.selected_number;
    const boughtPlanCode = currentEditPlan.plan_code;
    const boughtPlanQty = currentEditPlan.cartInfo?.selected_number ?? 0;
    return selectedPlanCode === boughtPlanCode && selectedPlanQty === boughtPlanQty;
  },
  isSelectedSameAsEditablePlansInBought: (state, getters) => {
    // shopping cart plans === ([init0 plans] ∩ [bought plans])   (excluding modified plans from coupon, etc.)
    if(window.newBillingConfig?.forcePlaceorderActive || window.forcePlaceorderActive) return false;
    if(getters.couponState?.couponCode) return false; // same plancode & quantity but with discount from campaign link coupon
    const { getSelectedPlans, editablePlansInBought } = getters;
    if (!editablePlansInBought.length) return false;
    // FREE TRIAL - the user could just bought a free trial plan with 0 price but same plan code with paid plan
    if(editablePlansInBought.some(plan => !!plan.freeTrialPlanInfo && plan.freeTrialPlanInfo.price === 0)) {
      return false;
    }
    if (getters.isMsqEdit) return getters.isSelectedSameAsEditablePlansInBoughtForMsqEdit;

    const arr = [editablePlansInBought, getSelectedPlans].map(plan => {
      return _.sortBy(plan, 'plan_code').reduce((acc, x) => acc + getDeterminePlanBeenEditedData(x), '');
    });
    return arr[0] === arr[1];
  },
  // @deprecated seems not used
  isSelectedCycleSameAsEditablePlansInBought: (state, getters) => {
    const { isSelectedSameAsEditablePlansInBought, getSelectedPlans, editablePlansInBought } = getters;
    if (isSelectedSameAsEditablePlansInBought) {
      return true;
    }
    let sameCycle = true;
    _.each(editablePlansInBought, function(plan) {
      const matchingItem = _.find(getSelectedPlans, tmp => tmp.type === plan.type);
      if (!matchingItem || matchingItem.billing_cycle !== plan.billing_cycle) {
        sameCycle = false;
      }
    });
    return sameCycle;
  },
  cartFingerPrint: (state, getters) => {
    // mainly to indicate that cart has changed
    // TODO not for plans like Zoom Phone
    const { getSelectedPlans } = getters;
    return getSelectedPlans.map(plan => getDeterminePlanBeenEditedData(plan)).join('\n');
  },
  // key is planCode, value is quantity
  getSelectedPlansWithQuantityMap: (_, getters) => {
    return reduce(getters.getSelectedPlans, (res, item) => {
      if (item.plan_code) {
        res[item.plan_code] = get(item, 'cartInfo.selected_number');
      }

      return res;
    }, {});
  },
  // key is planCode, value is quantity
  getSelectedFreeTrialPlansWithQuantityMap: (_, getters) => {
    return reduce(getters.getSelectedPlans, (res, item) => {
      if (item.plan_code && item.isOnlineFreeTrial) {
        res[item.plan_code] = get(item, 'cartInfo.selected_number');
      }
      return res;
    }, {});
  },
  // just generate order data with api payload params
  selectedPlanListPayLoad: (_, { getSelectedPlans }) => {
    return getSelectedPlanListPayLoad(getSelectedPlans);
  },
  selectedPlanListWithVendorProduct: (_, { getSelectedPlans }) => {
    return getSelectedPlanListPayLoad(getSelectedPlans, false);
  },
  couponPayload: (state, getters) => {
    const couponState = getters.couponState;
    const couponBuilder = createCouponPayloadBuilder(getters);

    const defaultCouponPayload = {
      ...getDefaultCouponPayload(),
      code: couponState?.couponCode,
      ...couponBuilder.getMidTermFeatureField(),
    };

    // for supported coupon case
    if (couponState.couponSourceType === couponSourceTypeMap.supportCoupon) {
      return {
        ...defaultCouponPayload,
        supportCoupon: true,
      };
    }

    // for promotion coupon code
    if (window.$context?.is?.fromPromoCodeCampaign && couponState?.couponCode) {
      return {
        ...defaultCouponPayload,
        fromCampaignLink: true,
      }
    }

    // NN/FREE or not from campaign link
    if (window.$context.is.basic2pro || window.$context.is.buyNow || !couponState?.fromPreloadLink) {
      return defaultCouponPayload;
    }

    if (window.$config('cp_source') === cancellationCouponSource) {
      return {
        ...defaultCouponPayload,
        cancelCampaign: true,
      };
    }

    return {
      ...defaultCouponPayload,
      fromCampaignLink: true,
    };
  },
  orderDataPayload: (_, getters) => {
    const couponVerifyStatus = getters.verifyCouponStatus;

    return {
      planList: getters.selectedPlanListPayLoad,
      coupon: couponVerifyStatus !== couponFetchStatus.failure ?
        getters.couponPayload : getDefaultCouponPayload(),
    }
  },
  // Merge bought plans and selected plans.
  getUserCurrentSubscriptions: (state, getters) => {
    const boughtPlans = boughtPlanFilter(getters);

    const allPlans = [
      ...boughtPlans,
      ...getters.getSelectedPlans,
    ];
    let cacheKey = {};
    const mergedPlans = [];
    allPlans.forEach(item => {
      if (cacheKey[item.plan_code]) {
        return;
      }
      const { plan_code } = item;
      const selectedPlan = getters.getSelectedPlans.find(_item => _item.plan_code === plan_code);
      if (selectedPlan) {
        mergedPlans.push(selectedPlan);
      } else {
        mergedPlans.push(item);
      }
      cacheKey[plan_code] = true;
    });
    cacheKey = null;
    return mergedPlans;
  },
  getSelectedPlansMap: (state, { getSelectedPlans }) => {
    return reduce(getSelectedPlans, (res, item) => {
      if (item.plan_code) {
        res[item.plan_code] = item;
      }
      return res;
    }, {});
  },
  getSelectedPlansAmount: (state, getters) => {
    const { getSelectedPlans, boughtPlans } = getters;

    // Refer a friend discount applies to 2 billing cycles for monthly plan
    let monthlyAmount = getReferAFriendDiscountAmount();
    // Refer a friend discount applies to one billing cycle for annual plan. Hence, no refer a friend discount for annual billing cycle
    let annualAmount = getInrDiscountAmount();
    let quarterlyAmount = 0;
    let twoYearsAmount = 0;
    let threeYearsAmount = 0;
    let annualTermMonthlyAmount = getReferAFriendDiscountAmount();
    let totalAmount = getInrDiscountAmount() || getReferAFriendDiscountAmount();
    let totalAmountWithoutDiscount = 0; // ZOOM-1070534 'Subtotal' should represent the amount excluding the discount
    let plans = {};

    for (let i = 0; i < getSelectedPlans.length; i++) {
      const plan = getSelectedPlans[i];
      const { billing_cycle } = plan;
      let amount = 0;
      const boughtPlan = boughtPlans.find((bp) => bp.billing_cycle === plan.billing_cycle && bp.plan_code === plan.plan_code);

      if (boughtPlan?.ratePlans?.length > 1) {
        amount += getMultipleRatePlanSumPrice(boughtPlan, plan.cartInfo.selected_number);
      } else {
        const context = {
          currentLicense: boughtPlan?.cartInfo?.selected_number || 0
        };
        const effectiveAmount = getEffectiveAmount(plan, context);

        if (plan.billing_cycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY) {
          amount += effectiveAmount / billingCycleToValueMap[plan.billing_cycle] * plan.cartInfo.selected_number;
        } else {
          amount += effectiveAmount * plan.cartInfo.selected_number;
        }
      }

      if (billing_cycle === BILLING_CYCLE.ANNUAL) {
        annualAmount += amount;
      } else if (billing_cycle === BILLING_CYCLE.MONTHLY) {
        monthlyAmount += amount;
      } else if (billing_cycle === BILLING_CYCLE.QUARTERLY) {
        quarterlyAmount += amount;
      } else if (billing_cycle === BILLING_CYCLE.TWO_YEARS) {
        twoYearsAmount += amount;
      } else if (billing_cycle === BILLING_CYCLE.THREE_YEARS) {
        threeYearsAmount += amount;
      } else if (billing_cycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY) {
        annualTermMonthlyAmount += amount;
      }
      if (!plan.isOnlineFreeTrial) {
        totalAmount += amount;
        totalAmountWithoutDiscount += amount;
      }
      plans[plan.plan_code] = amount;
    }

    return {
      monthlyAmount,
      annualAmount,
      quarterlyAmount,
      twoYearsAmount,
      threeYearsAmount,
      annualTermMonthlyAmount,
      totalAmount,
      totalAmountWithoutDiscount,
      plans,
    };
  },
  getTotalCharge: (state, getters) => {
    const { getSelectedPlansAmount, planTotalDiscount, getSelectedPlans } = getters;

    // if the customer's shopping cart don't have any plans, should set default amount with zero
    if (planTotalDiscount > 0 && !getSelectedPlans.length) return 0;

    return (getSelectedPlansAmount.totalAmount - planTotalDiscount);
  },
  // for merge bought plans and selected plans
  getCurrentBasePlanInfo: (_, getters) => {
    return getBasePlanInfo(getters.getUserCurrentSubscriptions.filter(x => {
      return getters.basicConfig.isExpireAccountWithPaidPlan ? x.cancelled != 1 : true
    }))
  },
  getCurrentMeetingPlans: (_, getters) => {
    return getMeetingPlans(getters.getUserCurrentSubscriptions.filter(x => {
      return getters.basicConfig.isExpireAccountWithPaidPlan ? x.cancelled != 1 : true
    }))
  },
  getBoughtBasePlanInfo: (_, getters) => getBasePlanInfo(getters.boughtPlans),
  getSelectedBasePlanInfo: (_, getters) => getBasePlanInfo(getters.getSelectedPlans),
  getBoughtMeetingPlans: (_, getters) => getMeetingPlans(getters.boughtPlans),
  getSubscriptions(state){
    return state.subscriptions;
  },
  subscriptions: (state) => state.subscriptions,
  assignInfo: (state) => state.assignInfo,
  cmrUsedValue: (state) => state.cmrUsedValue,
  plancodeMapSubscriptionDisabled(state, getters){
    // plancode map subscription disabled status
    return planCodeMapSubscriptionDisabled(getters.getSubscriptions);
  },
  boughtPlansGroupByCategoryCode: (_, getters) => {
    return getters.boughtPlans.reduce((pre, item) => {
      pre[item.category] = pre[item.category] || [];
      pre[item.category].push(item);

      return pre;
    }, {});
  },
  currentEditPlan: (state, getters) => {
    // ! note currentEditPlan in vuex is the bought plan, not the selected plan.
    return _.find(getters.boughtPlans, (p) => {
      const planCodeList = [p?.plan_code, p?.mapping_plan_code].filter(Boolean);
      return _.includes(planCodeList, getters?.oldPlanCode);
    });
  },
  currentEditPlanMRRStatus(state, getters){
    const {currentEditPlan, getSelectedPlans} = getters;
    // in most cases, a user could edit only one plan
    // but for some, supplementary zoom one plans might be added, if so, MRR is sure to be CHANGE_NOW;
    if(getSelectedPlans.length > 1) return MRS_STATUS_TYPE_MAP.CHANGE_NOW;
    // check plan MRR status
    return checkMRSChange({oldPlan: currentEditPlan, nextPlan: getSelectedPlans[0]});
  },
  isCurrentEditUpSell(state, getters){
    return getters.currentEditPlanMRRStatus === MRS_STATUS_TYPE_MAP.CHANGE_NOW;
  },
  isCurrentEditDownSell(_, getters) {
    return getters.currentEditPlanMRRStatus === MRS_STATUS_TYPE_MAP.CHANGE_FUTURE;
  },
  isCurrentMeetingPlanDowngrade: (_, getters) => {
    const oldCategory = getters.currentEditPlan?.category;
    const newCategory = getters.getCurrentMeetingPlans[0]?.category;
    const orderZoneCategory = [ZOOM_MEETING_SUB_TYPES.PRO, ZOOM_MEETING_SUB_TYPES.PRO_PLUS, ZOOM_MEETING_SUB_TYPES.BIZ, ZOOM_MEETING_SUB_TYPES.BIZ_PLUS];
    return orderZoneCategory.indexOf(oldCategory) > orderZoneCategory.indexOf(newCategory)
  },
  smbShouldFollowTermEndDate: (_, getters) => {
    return getters.basicConfig?.isSMBCustomer
    && getters.basicConfig?.term !== getters.currentEditPlan?.cycleValue
    && (getters.isCurrentEditDownSell || getters.isCurrentMeetingPlanDowngrade);
  },
  shouldUseTermEndDate: (_, getters) => {
    //1.when smb customer product term and contract term are different, downgrade/downsell should be executed based on the contract term
    //2.when customer biz>pro, biz plus>biz, downgrade should be executed based on the contract term
    return getters.smbShouldFollowTermEndDate || getters.isCurrentMeetingPlanDowngrade || $context.is.biz2pro
  },
  isCancelAndReplaceSubscription: (_, getters) => {
    const oldCategory = getters.currentEditPlan?.category;
    const newCategory = getters.getSelectedPlans[0]?.category;
    const meetingScope = [ZOOM_MEETING_SUB_TYPES.EDUCATION, ZOOM_MEETING_SUB_TYPES.PRO, ZOOM_MEETING_SUB_TYPES.PRO_PLUS, ZOOM_MEETING_SUB_TYPES.BIZ, ZOOM_MEETING_SUB_TYPES.BIZ_PLUS];
    const isEditBaseZr = getters.account.accountType === AccountType.ACCOUNT_ZOOM_ROOM && getters.currentEditPlan?.category === ZoomRoomCategories.ZR;
    const isEditMeetingPlan = meetingScope.includes(oldCategory) && meetingScope.includes(newCategory);

    // cancellation campaign/marketing campaign
    const isAddCoupon = isFromCampaignLink() && (getters.verifyCouponStatus === couponFetchStatus.pending || getters.discountWithAmountMap?.totalDiscount > 0);
    if (isAddCoupon) return true;

    if (!isEditBaseZr && !isEditMeetingPlan) {
      return false;
    }

    const oldBillingCycle = getters.currentEditPlan?.billing_cycle;
    const newBillingCycle = getters.getSelectedPlans[0]?.billing_cycle;
    const isM2A = oldBillingCycle === BILLING_CYCLE.MONTHLY && newBillingCycle === BILLING_CYCLE.ANNUAL;


    if (isEditMeetingPlan) {
      //case 1: pro,biz,pro plus,biz plus edit flow m2a or use coupon
      if (oldCategory === newCategory) {
        return isM2A;
      }

      //case 2: upgrade flow m2a
      if (meetingScope.indexOf(oldCategory) <= meetingScope.indexOf(newCategory)) {
        return isM2A;
      }
    } else if (isEditBaseZr) {
      return isM2A;
    }

    return false
  },
  persistState: (state) => state.persistState,
  hasBoughtActiveNoneZPUsagePlan: (state, getters) => {
    return getters.boughtPlans.some(p => ([
      planTypes.ZOOM_ONE_BUNDLE,
      planTypes.ZOOM_UNITED,
      planTypes.ZONE_PRO_PLUS,
      planTypes.ZONE_EDU_PLUS,
    ].includes(p.type)) && !p.cartInfo?.cancelled);
  },
  hasBoughtDependPlan: (state, getters) => {
    const editPlanType = pageConfig?.editConfig?.planType;
    const curSelectedPlan = _.find(getters.getSelectedPlans, (p) => p.type === editPlanType);
    const dependBasePlanTypeList = _.get(curSelectedPlan, ["dependBasePlanTypeList"], []);

    if (!dependBasePlanTypeList?.length) return true;

    return !!_.find(getters.boughtPlans, (p) => {
      return _.includes(dependBasePlanTypeList, p.type) && (getters.basicConfig.isExpireAccountWithPaidPlan ? p.cancelled != 1 : true)
    });
  },
  unlimitedAudioLicense: (_, getters) => unlimitedAudioLicenseGetter(getters.getUserCurrentSubscriptions),
  plansofBizBundle: (_, getters) => plansofBizBundle(getters),
  migratePlanState: (state) => {
    const states = state.persistState.migratePlanState;
    let migrateType = states.migrateType;
    if (window.$context.is.biz2bundle) {
      migrateType = MIGRATE_FLOW_TYPES.biz2bundle;
    } else if (window.$context.is.pro2prop) {
      migrateType = MIGRATE_FLOW_TYPES.pro2prop;
    } else if (window.$context.is.prop2bundle) {
      migrateType = MIGRATE_FLOW_TYPES.prop2bundle;
    } else if (window.$context.is.pro2bundle) {
      migrateType = MIGRATE_FLOW_TYPES.pro2bundle;
    } else if (window.$context.is.esc2escp) {
      migrateType = MIGRATE_FLOW_TYPES.eduschcmp2eduschcmpplus
    }
    return {
      ...states,
      migrateType,
      is: {
        downgrade: states.flow === flowTypes.downgrade || window.$context.is.biz2pro,
        upgrade: states.flow === flowTypes.upgrade || window.$context.is.biz2bundle || window.$context.is.pro2prop || window.$context.is.prop2bundle || window.$context.is.pro2bundle || window.$context.is.pro2biz ||  window.$context.is.esc2escp,
        bundle2biz: states.migrateType === MIGRATE_FLOW_TYPES.bundle2biz,
        escp2esc: states.migrateType === MIGRATE_FLOW_TYPES.eduschcmpplus2eduschcmp,
        esc2escp: states.migrateType === MIGRATE_FLOW_TYPES.eduschcmp2eduschcmpplus,
        pro2bundle: states.migrateType === MIGRATE_FLOW_TYPES.pro2bundle,
        pro2biz: states.migrateType === MIGRATE_FLOW_TYPES.pro2biz || window.$context.is.pro2biz,
        biz2bundle: states.migrateType === MIGRATE_FLOW_TYPES.biz2bundle || window.$context.is.biz2bundle,
        biz2pro: states.migrateType === MIGRATE_FLOW_TYPES.biz2pro || window.$context.is.biz2pro,
        bundle2pro: states.migrateType === MIGRATE_FLOW_TYPES.bundle2pro,
        pro2prop: states.migrateType === MIGRATE_FLOW_TYPES.pro2prop || window.$context.is.pro2prop,
        prop2bundle: states.migrateType === MIGRATE_FLOW_TYPES.prop2bundle || window.$context.is.prop2bundle,
        biz2proplus: states.migrateType === MIGRATE_FLOW_TYPES.biz2proplus,
        bizplus2proplus: states.migrateType === MIGRATE_FLOW_TYPES.bizplus2proplus,
      }
    }
  },
  hasPendingRequest(_, getters) {
    return getters.subscriptions.reduce((prev, cur) => {
      prev[cur.plan_code] = cur.has_downgrade_request || cur.has_decrease_request || cur.has_same_pending_plan;
      return prev;
    }, {});
  },
  hasDowngradeRequest(_, getters) {
    return getters.subscriptions.reduce((prev, cur) => {
      prev[cur.plan_code] = cur.has_downgrade_request;
      return prev;
    }, {});
  },
  preloadCartInfo(state){
    return state.preloadCartInfo;
  },
  isDisableAdd2Cart() {
    return false
  },
  isOnlineFreeTrailAccount(state) {
    return isOnlineFreeTrailAccountBySubscriptions(state.subscriptions, state.freeTrialPlans);
  },
  isPrecise(state, _, rootState) {
    if ($context.is.buyTrial || $context.is.add2trial) return true;
    // (isNetNew || isPreviewable) && api no exception
    if ($context.is.basic2pro || $context.is.buyNow) {
      return rootState.Tax.isTaxEstimatedSuccess;
    }
    return false;
  },
  healthcareAvailable(state, getters) {
    return (
      $query.referrer === 'healthcare' &&
      ($context.is.buyNow || ($context.is.basic2pro && !getters.isOnlineFreeTrailAccount)) &&
      plansof(getters.getSelectedPlans).type(planTypes.ZOOM_MEETING).category(ZOOM_MEETING_SUB_TYPES.PRO).has()
    )
  },
  healthcareInfo(state, getters) {
    const { agreementAccepted = false, businessCountry = '' } = getters.healthcareAvailable ? state._healthcareInfo : {}
    const countryCode = getCountryCodeByBusinessCountry(businessCountry)
    return {
      ...state._healthcareInfo,
      agreementAccepted,
      businessCountry,
      countryCode,
    }
  },
  healthcareEligible(state, getters) {
    const { agreementAccepted, countryCode } = getters.healthcareInfo
    return agreementAccepted && countryCode === getters.addressInfo.country
  },
  selectedSingleUsePro(state, getters) {
    return getters.getSelectedPlans.find(p => p.type === planTypes.ZOOM_MEETING && p.billing_cycle === BILLING_CYCLE.ONE_TIME);
  },
  trialInfoList(state) {
    const result = []
    for (const campaignCode in state.trialInfoMap) {
      state.trialInfoMap[campaignCode].forEach(item => {
        result.push({
          ...item, campaignCode
        })
      })
    }
    return result
  },
  beforeTaxTotalAmount(state, getters) {
    const total = getters.getTotalCharge + getters.openInvoiceTotalAmount;
    return Math.max(total, 0);
  },
  includeTaxTotalAmount(state, getters) {
    const total = getters.getTotalCharge + getters.getTaxTotalAmount + getters.openInvoiceTotalAmount + getters.getDeskphoneTaxTotalAmount;
    return Math.max(total, 0);
  },
  omniTotalAmount(state, getters){
    if(getters.isProrated){
      return Math.max(0, getters.getTodaysTotal);
    };
    if(getters.getSelectedPlans.every(plan => !!plan.isOnlineFreeTrial)){
      return 0;
    };
    if($context.is.delta || getters.isInrCitEligible && getters.isProratedChargeAmountCalculated){
      return getters.getProratedChargeTotalAmount
    };
    if($context.is.modal){
      return getters.beforeTaxTotalAmount;
    };
    return getters.includeTaxTotalAmount;
  },
  sourcePlan: state => state.sourcePlan,
  ghostBasePlanType(state, getters){
    // ghostPlanType is used in the case where shopping cart is cleared / empty
    // all related addon plans (including base plan itself) can be displayed if there is a 'ghost' base plan as reference
    if(getters.getSelectedPlans.length == 0){
      return $context.type;
    };
    // e.g. 'zoom_meeting'
  },
  ghostBasePlanKey(state, getters){
    if(getters.ghostBasePlanType){
      return planTypes.map([getters.ghostBasePlanType])?.[0];
    }
    // e.g. 'ZOOM_MEETING'
  },
  computedAmountLoading: (_, getters) => getters.verifyCouponStatusLoading,
  isProFreeTrialAddAddonCase: (_, getters) => {
    // bought base plan is pro free trial
    // flow is add2cart
    return (
      pageConfig.type === flowTypes.add2cart &&
      getters.getBoughtMeetingPlans[0] &&
      getters.getBoughtMeetingPlans[0].isFreeTrial
    )
  },
  pastPlans: state => state.pastPlans,
  zcmDomainWarning: state => state.zcmDomainWarning,
  initialPlanCodes: state => state.initialPlanCodes,
  maxCycleValueBasePlan: (state, getters) => {
    const basePlans = getters.getCurrentBasePlanInfo?.plans || [];
    const nonCancelledPlans = basePlans.filter(p => {
      return !p?.cancelled;
    });
    return nonCancelledPlans.sort((a, b) => b.cycleValue - a.cycleValue)[0];
  },
  currentQuantityMap: (state) => {
    const map = new Map();
    state.subscriptions.forEach(subscription => {
      map.set(subscription.plan_code, subscription.quantity);
    });
    return map;
  },
  isPreventCBA_downgrade2BasicPlus: (_, getters) => {
    const enabled = getters.planUpdateFutureConfig.enablePlanUpdateFutureEffective && getters.planUpdateFutureConfig.enablePro2BasicPlus;
    const isOnline = getters.basicConfig?.salesChannel == ACCOUNT_SALE_CHANNEL.ONLINE;
    const isAccountPaused = getters.basicConfig?.isAccountPaused == true;
    const hasProMonthly1License = plansof(getters.boughtPlans).type(planTypes.ZOOM_MEETING).category(ZOOM_MEETING_SUB_TYPES.PRO).cycle(BILLING_CYCLE.MONTHLY).sum('license') === 1;
    const isBaiscPlus = plansof(getters.getSelectedPlans).category(...ZONE_BASIC_PLUS_CATEGORIES).has();
    const isDowngrade = $context.flow === flowTypes.downgrade;
    return enabled && isOnline && !isAccountPaused && hasProMonthly1License && isBaiscPlus && isDowngrade;
  }, 
  isPreventCBA_A2M: (_, getters) => {
    const enabled = getters.planUpdateFutureConfig.enablePlanUpdateFutureEffective && getters.planUpdateFutureConfig.enableBasePlanA2M;
    const isOnline = getters.basicConfig?.salesChannel == ACCOUNT_SALE_CHANNEL.ONLINE;
    const isA2M = getters.getSelectedPlans?.[0].billing_cycle === BILLING_CYCLE.MONTHLY && [BILLING_CYCLE.ANNUAL, BILLING_CYCLE.ANNUAL_TERM_MONTHLY].includes(getters.currentEditPlan?.billing_cycle);
    const isA2AM = getters.getSelectedPlans?.[0].billing_cycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY && [BILLING_CYCLE.ANNUAL].includes(getters.currentEditPlan?.billing_cycle);
    // const isNonDecrease = getters.getSelectedPlans?.[0]?.cartInfo?.selected_number >= getters.currentEditPlan?.cartInfo?.selected_number;
    const currentEditPlanType = getters.currentEditPlan?.type;
    const currentEditPlanCategory = getters.currentEditPlan?.category;
    const supportedPlanTypes = [planTypes.ZOOM_MEETING];
    const supportedCategories = [BASE_PLAN_SUB_TYPES.PRO, BASE_PLAN_SUB_TYPES.BIZ, BASE_PLAN_SUB_TYPES.ZONE_EDU_SCH_CMP];
    return enabled && isOnline && $context.is.edit && (isA2M || isA2AM) && supportedPlanTypes.includes(currentEditPlanType) && supportedCategories.includes(currentEditPlanCategory);
  },
};

const mutations = {
  destroyPersist(state) {
    state.persist = {};
  },
  setOldPlanCode(state, data) {
    state.oldPlanCode = data;
  },
  setIsZPAContext(state, data) {
    state.isZPAContext = data;
  },
  setRouterTempData(state, data) {
    state.routerTempData = data;
  },
  savePersist: debounce((state) =>{
    const map = {};
    let persist = state.planMapFlat.reduce((acc, x) => {
      map[x.plan_code] = x;
      if (x.cartInfo?.selected_number > 0) {
        acc[x.plan_code] = x.cartInfo;
        if (x.isOnlineFreeTrial) {
          acc[x.plan_code].trialInfo = {
            trialCode: x.trialCode,
            trialDays: x.trialDays,
            campaignCode: x.campaignCode,
            isOnlineFreeTrial: x.isOnlineFreeTrial,
          };
        }
      }
      return acc;
    }, {});

    emit(
      EVENT_TYPES.PERSIST_UPDATE,
      state.planMapFlat
        .filter((plan) => plan.cartInfo?.selected_number > 0)
        .map((selectPlan) => ({
          ...selectPlan,
          selected_number: selectPlan?.cartInfo?.selected_number,
        })),
    );


    persist = Object.fromEntries(
      _.sortBy(Object.entries(persist), ([plancode]) => {
        const plan = map[plancode];
        const type = plan?.type;
        const planType = planTypes[type];
        const index = state.draftPlanFilterKeys.indexOf(planType);
        return index;
      })
    )

    persist._ = +new Date();
    state.persist = persist;
  }, 500),
  removePersistTrialInfo(state, planCode) {
    for (let i in state.persist) {
      if (i === planCode) {
        delete state.persist[i].trialInfo;
      }
    }
  },
  setSelectedPlansMap0(state, data) {
    if (state.selectedPlansMap0[SELECTED_PLANS_MAP_0_KEY]) return;
    // V3-TODO
    // Vue.set(state.selectedPlansMap0, SELECTED_PLANS_MAP_0_KEY, data);
    state.selectedPlansMap0[SELECTED_PLANS_MAP_0_KEY] = data
  },
  updateSelectedPlansMap0(state) {
    if (!state.selectedPlansMap0[SELECTED_PLANS_MAP_0_KEY]) state.selectedPlansMap0[SELECTED_PLANS_MAP_0_KEY] = {};
    const map = {...state.selectedPlansMap0[SELECTED_PLANS_MAP_0_KEY]};
    state.planMapFlat.forEach((x)=>{
      const count = x.cartInfo?.selected_number;
      if(count > 0) map[x.plan_code] = count;
    });
    // V3-TODO
    // Vue.set(state.selectedPlansMap0, SELECTED_PLANS_MAP_0_KEY, map);
    state.selectedPlansMap0[SELECTED_PLANS_MAP_0_KEY] = map
  },
  setPlanMapFlat(state, data) {
    state.planMapFlat = data;
  },
  setIneligible(state, { ineligible = false, message = '' } = {}) {
    state.ineligible = ineligible;
    state.ineligibleMessage = message;
  },
  setPlanMapFlatRaw(state, data) {
    state.planMapFlatRaw = data;
  },
  setSubscriptions(state, data) {
    state.subscriptions = data;
  },
  setBoughtPlans(state, data) {
    emit(EVENT_TYPES.BOUGHT_PLANS_UPDATE, data.map(boughtPlan => ({
      ...boughtPlan,
      selected_number: boughtPlan?.cartInfo?.selected_number,
    })));
    state.boughtPlans = data;
  },
  setPastPlans(state, data) {
    state.pastPlans = data;
  },
  setInitialPlanCodes(state, data) {
    state.initialPlanCodes = data;
  },
  setFreeTrialPlans(state, data) {
    state.freeTrialPlans = data;
  },
  setPreloadCartInfo(state, data) {
    state.preloadCartInfo = data;
  },
  setInitPlansOrder(state, data) {
    state.initPlansOrder = data;
  },
  setDraftPlanFilterKeys(state, data) {
    if(!state.draftPlanFilterKeys.length && data.length && state.initPlansOrder.length) {
      // init with order
      const map = state.planMapFlat.reduce((acc, x) => {
        acc[x.plan_code] = x;
        return acc;
      }, {});
      const orderedInitPlans = state.initPlansOrder.map(x => map[x]);
      const orderedInitPlanTypes = orderedInitPlans.map(x => planTypes[x?.type]);
      const ordered = [];
      const notOrdered = [];
      data.forEach(x => {
        if(orderedInitPlanTypes.includes(x)) {
          ordered.push(x);
        }else{
          notOrdered.push(x);
        }
      });
      const order = [...ordered.sort((a, b) => orderedInitPlanTypes.indexOf(a) - orderedInitPlanTypes.indexOf(b)), ...notOrdered];
      state.draftPlanFilterKeys = order;
      state.initPlansOrder = [];
    }else{
      state.draftPlanFilterKeys = data;
    }
  },
  removeDraftPlanFilterKeysByKey(state, key) {
    const draftPlanFilterKeys = [...state.draftPlanFilterKeys];
    draftPlanFilterKeys.splice(
      state.draftPlanFilterKeys.findIndex((x) => x === key),      // FIXME: potential risk, when index return -1, this may delete the last one
      1,
    );
    this.commit('setDraftPlanFilterKeys', draftPlanFilterKeys);
  },
  setPlanFreeTrial(state, { type, planCode }) {
    let list = state.planMapFlat;
    if (type) {
      list = list.filter((item) => item.type === type);
    }
    if (planCode) {
      list = list.filter((item) => item.plan_code === planCode);
    }
    list.forEach((plan) => {
      const trialInfo = this.getters.trialInfoList.find((info) => info.planCode === plan.plan_code);
      plan.trialCode = trialInfo.trialCode;
      plan.trialDays = trialInfo.trialDays;
      plan.campaignCode = trialInfo.campaignCode;
      plan.isOnlineFreeTrial = true;
    });
    state.planMapFlat = [...state.planMapFlat];
    this.commit('savePersist');
  },
  removePlanFreeTrial(state, { type, planCode }) {
    let list = state.planMapFlat;
    if (type) {
      list = list.filter((item) => item.type === type);
    }
    if (planCode) {
      list = list.filter((item) => item.plan_code === planCode);
    }
    list.forEach((item) => {
      item.trialCode = '';
      item.trialDays = undefined;
      item.isOnlineFreeTrial = false;
      item.campaignCode = '';
    });
    state.planMapFlat = [...state.planMapFlat];
    this.commit('savePersist');
  },
  updateSelectPlan(state, { plan_code, planType, billing_cycle, category, cartInfo = getCartInfo() }) {
    if (cartInfo) {
      const targetPlan = isOnlineNotSupportPlan({ planType, billingCycle: billing_cycle, category })
        ? state.planMapFlat.find((item) => item.plan_code === plan_code && item.billing_cycle === billing_cycle)
        : state.planMapFlat.find((item) => item.plan_code === plan_code);
      if (targetPlan) {
        targetPlan.cartInfo = cartInfo;
      }
      this.commit('savePersist');
    }
  },
  updateSelectPlanByCategory(state, { category, billingCycle, cartInfo = getCartInfo() }) {
    if (cartInfo) {
      const categoryPlans = state.planMapFlat.filter((item) => item.category === category);
      categoryPlans.forEach((item) => {
        if (item.billing_cycle === billingCycle) {
          item.cartInfo = cartInfo;
        }
      });
      this.commit('savePersist');
    }
  },
  updateSelectPlans(state, plans) {
    const map = plans.reduce((acc, x) => ((acc[x.plan_code] = x.cartInfo || getCartInfo()), acc), {});
    state.planMapFlat.forEach((x) => {
      if (map[x.plan_code]) {
        x.cartInfo = map[x.plan_code];
      }
    });
    this.commit('savePersist');
  },

  removeDraftPlanFilterKeysByPlanCode(state, planCode) {
    const { planMapFlat, draftPlanFilterKeys } = state;
    const selectedPlans = planMapFlat.filter((v) => v.cartInfo?.selected_number > 0);
    const planTypeCountMap = selectedPlans.reduce((acc, cur) => {

      return {
        ...acc,
        [cur.type]: (acc[cur.type] ?? 0) + 1,
      };
    }, {});
    const currentPlanType = selectedPlans.find((plan) => plan.plan_code === planCode)?.type;
    if (planTypeCountMap[currentPlanType] === 1 && draftPlanFilterKeys.includes(planTypes[currentPlanType])) {
      this.commit('removeDraftPlanFilterKeysByKey', planTypes[currentPlanType]);
    }
  },

  removePlan(state, plan_code) {
    // Minimize scope of impact, Why limit it to the checkout page? For switch plan like whiteboard to whiteboard plus
    // draftPlanFilterKeys can't be removed. this simply remove the old plan code and assign a target plan code
    if(isFromShoppingCart() && $context.is.checkoutPage) {
      this.commit('removeDraftPlanFilterKeysByPlanCode', plan_code);
    }
    state.planMapFlat.forEach((item) => {
      if (item.plan_code === plan_code) {
        item.cartInfo = getCartInfo();
      }
    });
    this.commit('savePersist');
  },
  batchRemovePlan(state, planList = []) {
    const planCodeList = planList.map((p) => p.plan_code) || [];

    state.planMapFlat.forEach((p) => {
      if (planCodeList.includes(p.plan_code)) {
        p.cartInfo = getCartInfo();
      }
    });

    this.commit('savePersist');
  },
  setAllPlanMap(state, map) {
    state.allPlanMap = map;
  },
  // PRO INCREASE - Pro Monthly Price Increase
  updateProMonthlyPlanMap(state, { currentProMonthlyPlancode, month_plancode, month_amount, address }) {
    let proMonthlyPlan = state.planMapFlat.find((p) => p.plan_code === currentProMonthlyPlancode);
    if (proMonthlyPlan) {
      // Store the data for future restore
      state.proIncreaseMapMonthly = {
        address,
        oldPlanCode: proMonthlyPlan.plan_code,
        oldPlanAmount: proMonthlyPlan.amount,
        newPlanCode: month_plancode,
        newPlanAmount: month_amount,
      };
      // Update data
      proMonthlyPlan.plan_code = month_plancode;
      proMonthlyPlan.amount = month_amount;
    }
  },
  restoreProMonthlyPlan(state, { currentProMonthlyPlancode }) {
    let proMonthlyPlan = state.planMapFlat.find((p) => p.plan_code === currentProMonthlyPlancode);
    if (
      proMonthlyPlan &&
      !!state.proIncreaseMapMonthly.oldPlanAmount &&
      state.proIncreaseMapMonthly.oldPlanCode !== currentProMonthlyPlancode
    ) {
      // Restore data
      proMonthlyPlan.plan_code = state.proIncreaseMapMonthly.oldPlanCode;
      proMonthlyPlan.amount = state.proIncreaseMapMonthly.oldPlanAmount;
      // Reset the data
      state.proIncreaseMapMonthly = {
        address: undefined,
        oldPlanCode: undefined,
        oldPlanAmount: undefined,
        newPlanCode: undefined,
        newPlanAmount: undefined,
      };
    }
  },
  // PRO INCREASE - Pro Yearly Price Increase
  updateProYearlyPlanMap(state, { currentProYearlyPlancode, yearly_plancode, yearly_amount, address }) {
    let proYearlyPlan = state.planMapFlat.find((p) => p.plan_code === currentProYearlyPlancode);
    if (proYearlyPlan) {
      // Store the data for future restore
      state.proIncreaseMapYearly = {
        address,
        oldPlanCode: proYearlyPlan.plan_code,
        oldPlanAmount: proYearlyPlan.amount,
        newPlanCode: yearly_plancode,
        newPlanAmount: yearly_amount,
      };
      // Update data
      proYearlyPlan.plan_code = yearly_plancode;
      proYearlyPlan.amount = yearly_amount;
    }
  },
  restoreProYearlyPlan(state, { currentProYearlyPlancode }) {
    let proYearlyPlan = state.planMapFlat.find((p) => p.plan_code === currentProYearlyPlancode);
    if (
      proYearlyPlan &&
      !!state.proIncreaseMapYearly.oldPlanAmount &&
      state.proIncreaseMapYearly.oldPlanCode !== currentProYearlyPlancode
    ) {
      // Restore data
      proYearlyPlan.plan_code = state.proIncreaseMapYearly.oldPlanCode;
      proYearlyPlan.amount = state.proIncreaseMapYearly.oldPlanAmount;
      // Reset the data
      state.proIncreaseMapYearly = {
        address: undefined,
        oldPlanCode: undefined,
        oldPlanAmount: undefined,
        newPlanCode: undefined,
        newPlanAmount: undefined,
      };
    }
  },
  setCartIsReady(state, data) {
    state.cartIsReady = data;
  },
  setFlowInitIsReady(state, data) {
    state.flowInitIsReady = data;
  },
  setAssignInfo(state, data) {
    state.assignInfo = data;
  },
  setCmrUsedValue(state, data) {
    state.cmrUsedValue = data;
  },
  savePersistState(state, data = {}) {
    Object.keys(data).forEach((key) => {
      state.persistState[key] = data[key];
    });
  },
  saveCurrentEditPlan(state, data = {}) {
    state.currentEditPlan = data;
  },
  setMigratePlanState(state, data = {}) {
    Object.keys(data).forEach((k) => {
      state.persistState.migratePlanState[k] = data[k];
    });
  },
  setConfirmationDetails(state, data = {}) {
    Object.keys(data).forEach((k) => {
      state.persistState.confirmationDetails[k] = data[k];
    });
  },
  setAccountBizInfo(state, data = {}) {
    Object.keys(data).forEach(k => {
      state.persistState.accountBizInfo[k] = data[k];
    })
  },
  updateHealthcare(state, data = {}) {
    Object.keys(data).forEach((key) => {
      state._healthcareInfo[key] = data[key];
    });
  },
  updateTrialInfoMap(state, { campaignCode, list = [] }) {
    // Vue.set(state.trialInfoMap, campaignCode, list);
    state.trialInfoMap[campaignCode] = list
  },
  setSourcePlan(state, data) {
    state.sourcePlan = data;
  },
  setZcmDomainWarning(state, value) {
    state.zcmDomainWarning = value;
  }
};

const actions = {
  async initPageFlow({ dispatch, commit, getters }) {
    await pageFlow.beforeInit?.();

    if (getters.flowInitIsReady) {
      return;
    }

    await Promise.all([
      dispatch(ADDRESS_ACTION_TYPES.fetchCountryMap),
      dispatch('fetchENCountryMap')
    ]);
    await Promise.all([
      dispatch('initShoppingCart'),
      dispatch(PAYMENT_ACTION_TYPES.getPaymentInfo),
    ]);

    commit('setFlowInitIsReady', true);
  },
  async initShoppingCart({ commit, state, getters, dispatch }) {
    if (getters.cartIsReady) {
      return;
    }

    const {
      boughtPlans = [],
      subscriptions = [],
      planMapFlat = [],
      allPlanMap = {},
      assignResult = {},
      freeTrialPlans = [],
      cmrUsedValue = {},
      invoiceData = null,
      sourcePlan = null,
      pastPlans = [],
      oldPlanCode,
      ineligible = false,
      ineligibleMessage = '',
      isZPAContext = false,
    } = await pageFlow?.init(state);
    

    log('init:shopping-cart', planMapFlat.filter(x => x.cartInfo?.selected_number > 0));

    commit('setIneligible', { ineligible, message: ineligibleMessage });
    commit('setIsZPAContext', isZPAContext);
    commit('setAllPlanMap', allPlanMap);
    commit('setPlanMapFlat', planMapFlat);
    commit('setPastPlans', pastPlans);
    // setTimeout(()=>{
      // defer this to the very end so that other data init process such as ZP can catch up
      commit('setSelectedPlansMap0', planMapFlat.reduce((acc, x)=>{
        const count = x.cartInfo?.selected_number;
        if(count > 0) acc[x.plan_code] = count;
        return acc;
      }, {}));
    // }, 0)
    commit('setBoughtPlans', boughtPlans);
    commit('setSubscriptions', subscriptions);
    commit('setAssignInfo', assignResult);
    commit('setFreeTrialPlans', freeTrialPlans);
    commit('setCmrUsedValue', cmrUsedValue);
    commit('setOpenInvoiceState', invoiceData);
    sourcePlan && commit('setSourcePlan', sourcePlan);

    commit('setPreloadCartInfo', window.newBillingConfig?.preloadCartInfo || {});

    if (state.oldPlanCode === null) {
      commit('setOldPlanCode', oldPlanCode || pageConfig?.oldPlanCode || '');
    }

    await dispatch(COUPON_ACTION_TYPES.initCouponState);
    await dispatch(PROMOTION_ACTION_TYPES.initPromotionState);
    await dispatch(REFERRAL_ACTION_TYPES.initReferAFriendState);
    await pageFlow?.afterInit(state);

    commit("setCartIsReady", true);
    state.refreshCount++;
  },
  // todo about to be discarded
  switchSelectPlan({ commit, getters }, [oldCode, newCode, cartInfo]) {
    const oldPlanInfo = getters.getSelectedPlans.find(item => item.plan_code === oldCode);
    if (oldPlanInfo) {
      const _cartInfo = { ...(cartInfo || oldPlanInfo.cartInfo) };
      commit('updateSelectPlan', { plan_code: oldCode });
      commit('updateSelectPlan', { plan_code: newCode, cartInfo: _cartInfo });
    }
  },
  async switchSelectPlanAction({ commit, getters }, [oldCode, newPlan]) {
    const oldPlan = getters.getSelectedPlans?.find(item => item.plan_code === oldCode);

    await pageFlow?.beforeUpdate([oldPlan], [newPlan]);
    oldPlan && commit('updateSelectPlan', { plan_code: oldCode });
    newPlan && commit('updateSelectPlan', { plan_code: newPlan.plan_code, cartInfo: newPlan.cartInfo });
  },
  async switchBillingCycleAction({ commit, getters }, [oldCode, newPlan]) {
    const oldPlan = getters.getSelectedPlans?.find(item => item.plan_code === oldCode);

    await pageFlow?.beforeUpdate([oldPlan], [newPlan]);
    oldPlan && commit('updateSelectPlan', { plan_code: oldCode });
    newPlan && commit('updateSelectPlan', { plan_code: newPlan.plan_code, cartInfo: newPlan.cartInfo });
    return newPlan;
  },
  async switchCategoryAction({ commit, getters }, [category, newPlans]) {
    const oldPlans = getters.getSelectedPlans?.filter(item => item.category === category);

    await pageFlow?.beforeUpdate(oldPlans, newPlans);
    oldPlans.forEach(item => commit('updateSelectPlan', { plan_code: item.plan_code }));
    newPlans.forEach(item => commit('updateSelectPlan', { plan_code: item.plan_code, cartInfo: item.cartInfo }));
    return newPlans;
  },
  async switchPlanByTypeAction({ commit, getters }, [newPlan]) {
    const oldPlan = getters.getSelectedPlans?.find(item => item.type === newPlan.type);

    await pageFlow?.beforeUpdate([oldPlan], [newPlan]);
    oldPlan && commit('updateSelectPlan', { plan_code: oldPlan.plan_code });
    newPlan && commit('updateSelectPlan', { plan_code: newPlan.plan_code, cartInfo: newPlan.cartInfo });
    return newPlan;
  },
  async switchCapacityAction({ commit, getters }, [oldCode, newPlan]) {
    const oldPlan = getters.getSelectedPlans?.find(item => item.plan_code === oldCode);

    await pageFlow?.beforeUpdate([oldPlan], [newPlan]);
    oldPlan && commit('updateSelectPlan', { plan_code: oldCode });
    newPlan && commit('updateSelectPlan', { plan_code: newPlan.plan_code, cartInfo: newPlan.cartInfo });
    return newPlan;
  },
  async removePlanAction({ commit, getters }, planCode) {
    const oldPlan = getters.getSelectedPlans?.find(item => item.plan_code === planCode);
    await pageFlow?.beforeUpdate([oldPlan]);
    planCode && commit('removePlan', planCode);
  },
  async batchRemovePlanAction({ commit }, planList = []) {
    await pageFlow?.beforeUpdate(planList);
    planList && planList.forEach((p) => commit("removePlan", p?.plan_code));
  },
  async fetchTrialInfos({ commit, state }, campaignCode) {
    if (state.trialInfoMap[campaignCode]) {
      return
    }
    const list = (await getFreeTrialPlansByCampaignName(campaignCode)).result || []
    commit('updateTrialInfoMap', {campaignCode, list})
    return list
  },
  groomDraftPlanFilterKeys({ commit, getters }) {
    // remove unnecessary draft keys that are not in the cart
    const cartPlanKeys = new Set();
    getters.getSelectedPlans.forEach((plan) => {
      const type = planTypes[plan.type];
      cartPlanKeys.add(type);
    });
    const draftPlanFilterKeys = getters.draftPlanFilterKeys.filter((key) => cartPlanKeys.has(key));
    commit('setDraftPlanFilterKeys', draftPlanFilterKeys);
  },
  switchPlanToTrialByType({ commit, getters }, type ) {
    getters.trialInfoList.filter((item) => item.type === type).forEach((trialInfo) => {
      commit('setPlanFreeTrial', {
        planCode: trialInfo.planCode,
        trialCode: trialInfo.trialCode,
        trialDays: trialInfo.trialDays,
        campaignCode: trialInfo.campaignCode
      })
    })
  },
  removePlanByKey({ commit, getters }, key) {
    // force remove even if it is not in draftPlanFilterKeys
    let force = false;
    if(typeof(key) !== "string" && key.key){
      force = key.force
      key = key.key
    };
    // fix: plan key is lowercase, can't remove from draftPlanFilterKeys
    if (key === key?.toLowerCase?.()) {
      key = planTypes?.[key] ?? key
    }
    if (getters.draftPlanFilterKeys.includes(key) || force) {
      commit('removeDraftPlanFilterKeysByKey', key)
      const planType = planTypes[key];
      const currentSelectedPlans = getters.getSelectedPlans.filter((plan) => plan.type === planType);
      currentSelectedPlans.forEach((plan) => commit('removePlan', plan?.plan_code));
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
